import React from "react";
import { TableRow } from "~/components/common/parts/table/TableRow";
import { SummaryFileTemplateRowNoSetting } from "~/components/specifics/settings/file_templates/SummaryFileTemplateRowNoSetting";
import { SummaryFileTemplateRowUploaded } from "~/components/specifics/settings/file_templates/SummaryFileTemplateRowUploaded";
import { useSummaryFileTemplates } from "~/hooks/useSummaryFileTemplates";
import type { SummaryFileTemplateType } from "~/models/SummaryFileTemplate";
import { summaryFileTemplateDetails } from "~/models/SummaryFileTemplate";

type Props = {
	fileType: SummaryFileTemplateType;
};

export const SummaryFileTemplateRow: React.FC<Props> = ({
	fileType
}: Props) => {
	const { data: templates } = useSummaryFileTemplates().useIndex();
	const template = React.useMemo(() => {
		if (templates === null) return null;
		return templates.find((t) => t.templateType === fileType) ?? null;
	}, [fileType, templates]);
	if (templates === null) {
		return null;
	}

	return (
		<TableRow>
			<td>{summaryFileTemplateDetails[fileType].section}</td>
			<td>{summaryFileTemplateDetails[fileType].address}</td>
			<td>{summaryFileTemplateDetails[fileType].type}</td>
			<td>
				{template === null ? (
					<SummaryFileTemplateRowNoSetting fileType={fileType} />
				) : (
					<SummaryFileTemplateRowUploaded template={template} />
				)}
			</td>
		</TableRow>
	);
};
